import { add as addRequest } from 'serviceWorker/db/httpRequests';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { InspectionTemplateChecklistItemHttpDeleteRequestModel } from '../httpQueue/inspectionTemplate/types';

export class InspectionTemplateChecklistItemRemover {
  constructor(
    private addRequest: (
      request: InspectionTemplateChecklistItemHttpDeleteRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    templateId: string,
    checklistItemId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    await this.addRequest({
      createdAt: Date.now(),
      method: 'DELETE',
      data: {
        uniqueId,
      },
      url: `/project/${projectId}/inspectionTemplate/${templateId}/checklistItem/${checklistItemId}`,
      entityType: HttpRequestModelType.inspectionTemplate,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionTemplateChecklistItemRemover =
  new InspectionTemplateChecklistItemRemover(addRequest);
